// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"ProfileButton-styles_dropdown__2rxWa","item":"ProfileButton-styles_item__Ftst6","link":"ProfileButton-styles_link__2JDX1"};